export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "pl-PL",
    "Messages": {
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "",
        "Administracja": "",
        "Adres": "",
        "Adres serwera katalogowego.": "",
        "Adres, pod który panel wysyła powiadomienia.": "",
        "Aktywna": "",
        "Aktywne źródła": "",
        "Aktywny": "",
        "Anuluj": "",
        "bez prefiksu": "",
        "Bezpieczeństwo": "",
        "Brak przypisanych użytkowników": "",
        "Brak wydziału": "",
        "Brak wyników": "",
        "Brak zdefiniowanych zespołów.": "",
        "Bramka SMS": "",
        "Ciemne tło": "",
        "Ciemnoczerwona": "",
        "Ciemnozielona": "",
        "Czerwiec": "",
        "Członkowie zespołu": "",
        "Data dodania": "",
        "Data opuszczenia zespołu": "",
        "Data rozpoczęcia": "",
        "Data utworzenia": "",
        "Data użycia": "",
        "Data wygaśnięcia": "",
        "Data zakończenia": "",
        "dni": "",
        "dnia": "",
        "Do": "",
        "Dodaj": "",
        "Dodaj dział": "",
        "Dodaj token": "",
        "Dodaj użytkownika": "",
        "Dodaj użytkownika do zespołu": "",
        "Dodaj użytkownika, korzystając z pola powyżej.": "",
        "Dodaj zastępstwo": "",
        "Dodaj zespół": "",
        "Dodaj źródło": "",
        "Dodanie działu": "",
        "Dodanie zastępstwa": "",
        "Dodanie zespołu": "",
        "Dodanie źródła": "",
        "Dodatkowe informacje o zastępstwie": "",
        "Dokumentacja": "",
        "Domena": "",
        "Domena użytkowników źródła.": "",
        "Domyślna": "",
        "Domyślnie 389, LDAPS 636.": "",
        "Dział aktywny": "",
        "Dział nadrzędny": "",
        "Dział został dodany.": "",
        "Dział został usunięty.": "",
        "Dział został zaktualizowany.": "",
        "Działy z katalogu zostaną odwzorowane jako grupy w panelu.": "",
        "Edycja działu": "",
        "Edycja i publikacja treści": "",
        "Edycja zastępstwa": "",
        "Edycja zespołu": "",
        "Edycja źródła": "",
        "Edytuj": "",
        "Edytuj członka grupy": "",
        "Edytuj wpis": "",
        "Filtr działów": "",
        "Filtr użytkowników": "",
        "Filtrowanie": "",
        "Filtruj członków zespołu": "",
        "Filtruj członków…": "",
        "Fioletowa": "",
        "Firebase": "",
        "Firebase config": "",
        "Format, w jakim użytkownik podaje login.": "",
        "Gotowe": "",
        "Grafitowa": "",
        "Grudzień": "",
        "Hasło": "",
        "Hasło konta usługowego.": "",
        "Host": "",
        "Identyfikator nadawcy z konsoli Firebase.": "",
        "Imię i nazwisko": "",
        "Inspekcja": "",
        "Integracja z Firebase": "",
        "Integracja z Microsoft Teams": "",
        "Integracja z platformą SMSAPI.pl": "",
        "Jasne tło": "",
        "Jeśli użytkownika nie ma na liście, uzupełnij jego dane (Imię i Nazwisko) w dziale Użytkownicy.": "",
        "Jesteś programistą?": "",
        "Język": "",
        "Key": "",
        "Key pair": "",
        "Kolor drugorzędny: %0": "",
        "Kolor icon na panelu z aplikacjami: %0": "",
        "Kolor podstawowy: %0": "",
        "Kolor tekstu aktywnej pozycji menu: %0": "",
        "Kolor tła panelu z aplikacjami: %0": "",
        "Kolory zostały przywrócone.": "",
        "Kolory zostały zapisane.": "",
        "Konfiguracja aplikacji web z konsoli Firebase.": "",
        "Koniec okresu zastępstwa.": "",
        "Konta użytkowników zostały przypisane do zespołu": "",
        "Konto": "",
        "Konto do odpytywania katalogu.": "",
        "Konto usługowe": "",
        "Kopiuj": "",
        "Krótki opis zespołu": "",
        "Kto i kogo zastępuje w wybranym okresie.": "",
        "Kwiecień": "",
        "LDAPS (LDAP over SSL)": "",
        "Liczba wyników": "",
        "Lider": "",
        "Lipiec": "",
        "Listopad": "",
        "Login": "",
        "Luty": "",
        "Maj": "",
        "Maks. 11 znaków, bez polskich liter.": "",
        "Marzec": "",
        "Microsoft Teams": "",
        "Miesiąc": "",
        "Moje konto": "",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Nadawca": "",
        "Nazwa": "",
        "Nazwa działu": "",
        "Nazwa na liście źródeł.": "",
        "Nazwa użytkownika": "",
        "Nazwa zespołu": "",
        "Nazwa źródła": "",
        "Nie": "",
        "Nie masz dostępu do tego modułu": "",
        "Nie udało się pobrać listy działów": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy wydziałów": "",
        "Nie udało się pobrać listy zespołów": "",
        "Nie udało się pobrać projektu MCP. Spróbuj ponownie.": "",
        "Nie udało się pobrać tokenów": "",
        "Nie udało się wczytać członków zespołu": "",
        "Nie udało się wczytać działu": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nieaktywna": "",
        "nieaktywne": "",
        "Nieaktywne źródło nie bierze udziału w logowaniu.": "",
        "Niebieska": "",
        "Nowy token dostępu": "",
        "np. AD Warszawa": "",
        "np. Redaktorzy": "",
        "Od": "",
        "Okres i szczegóły": "",
        "Określ indywidualne uprawnienia przypisane do zespołu.": "",
        "Opcje": "",
        "Opcjonalna informacja wyjaśniająca zakres zastępstwa.": "",
        "Opcjonalnie opisz zadania lub przeznaczenie zespołu.": "",
        "Opis": "",
        "Opis zespołu": "",
        "Organizacja": "",
        "Organizacja została usunięta.": "",
        "Osoba zastępowana": "",
        "Osoba zastępująca": "",
        "Osoby": "",
        "Paleta kolorów": "",
        "Panel może przekazywać powiadomienia do wskazanego kanału. Uzupełnij dane otrzymane od administratora Microsoft Teams.": "",
        "Panel wysyła powiadomienia push przez projekt Firebase. Po zmianie danych wcześniejsze urządzenia mogą wymagać ponownej rejestracji.": "",
        "Październik": "",
        "Pełny dostęp do systemu": "",
        "Plik konta usługowego w formacie JSON.": "",
        "Pobierz projekt dla Claude Code": "",
        "Pobierz projekt dla Codexa": "",
        "Pobierz starter teraz – po zamknięciu tego widoku pełny token nie będzie ponownie dostępny.": "",
        "Początek okresu zastępstwa.": "",
        "Podaj nazwę, która pozwoli łatwo rozpoznać zespół.": "",
        "Pokaż": "",
        "Pokaż hasło": "",
        "Pokaż token": "",
        "Połącz Edito z asystentem AI": "",
        "Połączenie szyfrowane - port zwykle 636.": "",
        "Połączenie z MCP — instrukcja": "",
        "Pole \"Liczba wyników\" jest wymagane.": "",
        "Pole \"Nadawca\" jest wymagane.": "",
        "Pole \"Testowy numer telefonu\" jest wymagane.": "",
        "Pole \"Token\" jest wymagane.": "",
        "Popraw błędy formularza przed zapisaniem.": "",
        "Port": "",
        "Potwierdzenie rotacji tokenu": "",
        "Potwierdzenie usunięcia": "",
        "Pozostaw puste, aby nie zmieniać.": "",
        "Pozostaw puste, aby utworzyć token bezterminowy. Maksymalny okres ważności wynosi 365 dni.": "",
        "Predefiniowane tła panelu z aplikacjami": "",
        "Predefiniowane zestawy kolorów": "",
        "Projekt został pobrany. Rozpakuj go, utwórz nowy projekt w wybranym programie i wskaż rozpakowany folder.": "",
        "Przetestuj ustawienia SMS": "",
        "Przykład: domena\\użytkownik": "",
        "Przykład: użytkownik": "",
        "Przykład: użytkownik@domena": "",
        "Przypisanie do zespołu": "",
        "Przywróć domyślne": "",
        "Publiczny klucz VAPID aplikacji web.": "",
        "Puste pole oznacza wartość domyślną: (&(objectClass=organizationalUnit)).": "",
        "Puste pole oznacza wartość domyślną: (&(objectClass=user)).": "",
        "Rok": "",
        "Role i uprawnienia": "",
        "Role zespołu": "",
        "Root": "",
        "Rotuj": "",
        "Sekcje użytkownika": "",
        "SenderId": "",
        "Serwer": "",
        "Sierpień": "",
        "Skonfiguruj połączenie standardowo w repozytorium – zarówno dla Codexa, jak i Claude Code użyj lokalnego pliku": "",
        "Skopiowano": "",
        "Spróbuj ponownie": "",
        "Strona główna": "",
        "Styczeń": "",
        "Synchronizacja": "",
        "System": "",
        "Szukaj po nazwie…": "",
        "Ta opcja jest przeznaczona dla redaktorów i użytkowników nietechnicznych. Wybierz program, z którego korzystasz.": "",
        "Tak": "",
        "Testowy numer telefonu": "",
        "Token": "",
        "Token OAuth z panelu SMSAPI. Przechowujemy go zaszyfrowany.": "",
        "Token przechowuj wyłącznie w tym ignorowanym przez Git pliku.": "",
        "Token utworzony": "",
        "Token został usunięty.": "",
        "Token został zrotowany.": "",
        "Tokeny": "",
        "Tokeny dostępu": "",
        "Tokeny zostały usunięte.": "",
        "Twój token": "",
        "Tworzenie i edycja wpisów": "",
        "Tylko liderzy": "",
        "Typ logowania": "",
        "Ukryj": "",
        "Ukryj hasło": "",
        "Ukryj token": "",
        "Uprawnienia": "",
        "Uprawnienia zespołu": "",
        "Ustal początek i koniec zastępstwa. Opcjonalnie dodaj opis jego zakresu.": "",
        "Ustawienia": "",
        "Ustawienia zostały zapisane.": "",
        "Usuń": "",
        "Usuń dział": "",
        "Usuń z zespołu": "",
        "Utwórz grupy": "",
        "Utwórz token": "",
        "Uwzględnij wydziały podrzędne": "",
        "Uzupełnij wymagane pola przed testem.": "",
        "Użytkownicy": "",
        "Użytkownik": "",
        "Użytkownik dodany": "",
        "Użytkownik dodany do zespołu": "",
        "Użytkownik jest liderem zespołu": "",
        "Użytkownik nie należy do żadnego zespołu.": "",
        "Użytkownik został dodany do zespołu.": "",
        "Użytkownik został usunięty z zespołu.": "",
        "W organizacji nie ma jeszcze żadnych działów.": "",
        "W zespole": "",
        "W zespole od %0 %1": "",
        "Wczytywanie": "",
        "Węzeł startowy wyszukiwania.": "",
        "Wiadomość testowa została wysłana.": "",
        "Wiadomości wychodzą przez konto SMSAPI - token wygenerujesz w panelu platformy w sekcji „Ustawienia → API”. Nazwa nadawcy musi być zatwierdzona przez operatora, inaczej SMS-y wyjdą z pola nadawcy „Info”.": "",
        "Włącz, jeśli zespół jest obecnie używany.": "",
        "Wpis został zaktualizowany.": "",
        "Wrzesień": "",
        "Wybierz opcję": "",
        "Wybierz role określające uprawnienia zespołu.": "",
        "Wybierz użytkownika…": "",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "",
        "Wydział": "",
        "Wydział organizacji, do którego przypisany jest użytkownik.": "",
        "wygasł": "",
        "Wypełnij, jeśli połączenie wymaga autoryzacji.": "",
        "Wyślemy jednego SMS-a testowego na podany numer - koszt zgodnie z cennikiem operatora.": "",
        "Zablokowany": "",
        "Zacznij pisać, aby wyszukać użytkownika…": "",
        "Zamknij": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zastępstwa": "",
        "Zastępstwo wygasło.": "",
        "Zastępstwo wygaśnie za 10 minut.": "",
        "Zastępstwo wygaśnie za 5 minut.": "",
        "Zastępstwo wygaśnie za minutę.": "",
        "Zastępstwo zostało dodane.": "",
        "Zastępstwo zostało usunięte.": "",
        "Zastępstwo zostało zaktualizowane.": "",
        "Zastępuje": "",
        "Zastępuje osobę": "",
        "Zawiera": "",
        "Zaznacz pole obok, aby ustawić lub zmienić hasło.": "",
        "Zespół": "",
        "Zespół aktywny": "",
        "Zespół został dodany.": "",
        "Zespół został usunięty.": "",
        "Zespół został zaktualizowany.": "",
        "Zespoły": "",
        "Zmień filtrowanie, aby zobaczyć członków zespołu.": "",
        "Zmień hasło": "",
        "Źródła LDAP": "",
        "Źródło aktywne": "",
        "Źródło LDAP zostało dodane.": "",
        "Źródło LDAP zostało zaktualizowane.": "",
        "Źródło zostało usunięte.": ""
    }
};
